import React, { useRef } from 'react';
import styles from './ProjectsSidebar.module.css';

interface Project {
  projectId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  versions?: ResumeVersion[];
  isExpanded?: boolean;
  nameStreaming?: boolean;
  tempName?: string;
}

interface ResumeVersion {
  versionId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

interface ProjectsSidebarProps {
  projects: Project[];
  activeProjectId: string | null;
  activeVersionId: string | null;
  onProjectSelect: (projectId: string, versionId: string) => void;
  onNewProject: () => void;
  onRefreshProjects: () => void;
  isExpanded: boolean;
}

const ProjectsSidebar: React.FC<ProjectsSidebarProps> = ({
  projects,
  activeProjectId,
  activeVersionId,
  onProjectSelect,
  onNewProject,
  onRefreshProjects,
  isExpanded,
}) => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  const handleProjectClick = (projectId: string) => {
    // Call onProjectSelect with empty versionId - parent component can handle version selection
    onProjectSelect(projectId, '');
  };

  return (
    <div 
      className={`${styles.sidebar} ${isExpanded ? styles.sidebarExpanded : styles.sidebarCollapsed}`}
      ref={sidebarRef}
    >
      {isExpanded ? (
          <>
            <div className={styles.sidebarHeader}>
              <h2 className={styles.sidebarTitle}>Projects</h2>
            </div>
            <div className={styles.sidebarContent}>
              <div className={styles.projectsList}>
                {projects.map(project => {
                  const isProjectActive = project.projectId === activeProjectId;
                  
                  return (
                    <div 
                      key={project.projectId}
                      className={`${styles.projectItem} ${isProjectActive ? styles.projectItemActive : ''}`}
                      onClick={() => handleProjectClick(project.projectId)}
                    >
                      <div className={styles.projectName}>
                        {project.nameStreaming && project.tempName !== undefined ? (
                          <span className={styles.streamingName}>
                            {project.tempName}
                            <span className={styles.streamingCursor}>|</span>
                          </span>
                        ) : (
                          project.name
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
      ) : null}
    </div>
  );
};

export default ProjectsSidebar;